<template>
  <div>
    <footer class="footer" id="footer">
      <div class="container">
        {{ currentYear }} &copy; {{ $mySite.title }}
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.footer{
  text-align: center;
}
</style>